<script>
  import {getContext} from 'svelte';
  import {PATHS} from '@/const/paths';
  import {sd} from '@/da/sd';
  import {fixLink$} from '@/store/lang';
  import MenuItemView from '../components/MenuItemView.svelte';
  import lang from '../../Header.lang';

  const LG = getContext('LG');

  function handleEarnClickFuc(item) {
    return function () {
      if (item === 'launchpool') {
        sd.track('launchpool_button_click', {button_name: 'launchpool'});
      }
      sd.track('web_click', {$screen_name: 'home', $element_content: 'navigation_earn_' + item});
    };
  }
</script>

<style>
  .wrap {
    box-sizing: border-box;
    padding: 16px;
    width: 328px;
    background: rgba(26, 29, 31, 0.96);
    backdrop-filter: blur(10px);
    cursor: default;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
</style>

<div class="wrap df fdc T2 ovh">
  <MenuItemView
    theme="dark"
    iconUrl="https://img.phemex.com/v1/f356fdf3-3ed5-4fda-ae1b-c2a60e331188/property-1-phemex-earn.svg"
    iconAlt="earn crypto"
    link={$fixLink$(PATHS.EARN_HOME.pathname)}
    target="_self"
    title={LG(lang.EarnCrypto)}
    subTitle={LG(lang.EarnCryptoEarnUpTo)}
    on:click={handleEarnClickFuc('phemex_earn')}
    noArrow
  />
  <MenuItemView
    theme="dark"
    iconUrl="https://img.phemex.com/v1/76c1370b-ff89-4d3e-ac16-152dedb68453/property-1-phemex-saving.svg"
    iconAlt="savings"
    link={$fixLink$(PATHS.EARN.pathname)}
    target="_self"
    title={LG(lang.Savings)}
    subTitle={LG(lang.EarnUpTo)}
    on:click={handleEarnClickFuc('phemex_savings')}
    noArrow
  />
  <MenuItemView
    theme="dark"
    iconUrl="https://img.phemex.com/v1/8c8a6eb1-d461-4212-aa25-a18f2b28d930/property-1-phemex-launchpool.svg"
    iconAlt="launchpool"
    link={$fixLink$(PATHS.LAUNCHPOOL.pathname)}
    target="_self"
    title={LG(lang.Launchpool)}
    subTitle={LG(lang.StakeAndEarn)}
    on:click={handleEarnClickFuc('launchpool')}
    noArrow
  />
</div>
